import { createSelector } from 'reselect';

const getMovie = state => state.getIn(['movies', 'movie']);

export const selectCurrentMovie = createSelector([getMovie], movie => (movie.get('id') ? movie : null));

export default {
  selectCurrentMovie
};
